import {
    DataTypes,
    DynamicFilterOperations,
    FilterOperations,
    SlidingTimeScales,
    TimeScales,
} from 'business/definitions';
import { has, isNil, map } from 'lodash';

/**
 * This user-defined type guard check that key is effectively a key of the given object
 * and narrows its type down to the possible key values of the object.
 * @param obj
 * @param key
 * @returns boolean
 */
export function isKeyOf<T extends object>(
    obj: T,
    key: string | number | symbol,
): key is keyof T {
    return key in obj;
}

export const asFilterValues = (filters: (string | number)[]): FilterValueT[] =>
    map(filters, (f) => ({ label: '', value: `${f}` }));

const isFilterOperator = (
    op: string | undefined,
): op is FilterOperationsT | DynamicFilterOperationsT =>
    op !== undefined &&
    (has(FilterOperations, op) || has(DynamicFilterOperations, op));

const isTimeScales = (
    valueScale: string | undefined,
): valueScale is TimeScalesT =>
    valueScale !== undefined &&
    (has(TimeScales, valueScale) || has(SlidingTimeScales, valueScale));

const isDataTypes = (type: string | undefined): type is DataTypesT =>
    type !== undefined && has(DataTypes, type);

export const isSentenceFilter = (
    filter: SentenceFilterT | QueryFilterT | ExploreFilterT,
): filter is SentenceFilterT => {
    const valueScaleIsValidOrNull =
        !('valueScale' in filter) ||
        ('valueScale' in filter &&
            (isNil(filter.valueScale) || isTimeScales(filter.valueScale)));
    const typeIsValid = 'type' in filter && isDataTypes(filter?.type);
    const operatorIsValid =
        'operation' in filter && isFilterOperator(filter?.operation);
    return (
        'field' in filter &&
        typeIsValid &&
        operatorIsValid &&
        valueScaleIsValidOrNull
    );
};
